<div class="modal-content-header semi-bold">
  <span>
    <span class="check-circle" *ngIf="showSuccessIcon">
    <i class="fa fa-check-circle" aria-hidden="true"></i>
  </span>
    <span class="header" [ngClass]="textTransformNone ? 'text-transform-none':''">
      {{headerName}}
    </span>
    <span class="sub-header">- {{ subHeaderName }}</span>
  </span>
  <div class="spacer"></div>
  <ng-content></ng-content>
  <div class="spacer"></div>
  <span class="cursor-pointer close-icon" *ngIf="showCloseBtn" (click)="closePopup()">
    <i class="fa fa-times" aria-hidden="true"></i>
  </span>
</div>
